import { get } from 'lodash'

export const getHighlightLinks = state => {
  return get(state, 'application.workspaceOverview.highlightLinks')
}
